<template>
  <q-card flat class="full-height">
    <template v-if="editableForm">
      <q-card-section class="q-py-none text-subtitle-2 text-secondary-2">
        <Grid gaf="column" justify-content="space-between" align-items="center">
          {{ editableForm.name || '' }}
          <slot name="header-actions"></slot>
        </Grid>
      </q-card-section>
      <q-card-section>
        <div class="row q-col-gutter-md">
          <template v-for="(field, index) in editableForm.content">
            <q-field
              v-if="field.tag === 'q-option-group'"
              :key="`field_${index}`"
              :hint="field.settings.helper"
              :label="field.tag === 'q-option-group' ? field.settings.label : ''"
              orientation="vertical"
              stack-label
              class="col-xs-12 option-group"
            >
              <template #control>
                <component
                  :is="field.tag"
                  :id="`field_${field.index}`"
                  v-model="field.settings.value"
                  :class="{
                    'lm-radio-group': field.tag === 'q-option-group' && field.type === 'radio',
                    'lm-checkbox-group': field.tag === 'q-option-group' && field.type === 'checkbox'
                  }"
                  class="q-mt-sm q-gutter-y-sm"
                  :type="field.type"
                  :label="field.settings.label"
                  :rows="field.settings.rows"
                  :options="field.settings.options || []"
                  outlined
                  dense
                  color="tertiary"
                  @input="rehashEditedForm()"
                  @change="rehashEditedForm()"
                />
              </template>
            </q-field>
            <div
              v-else-if="field.tag === 'q-input' || field.tag === 'q-select'"
              :key="`input_${index}`"
              class="col-12 row"
            >
              <component
                :is="field.tag"
                :id="`field_${field.index}`"
                v-model="field.settings.value"
                :hint="field.settings.helper"
                :type="field.type"
                :label="field.settings.label"
                :placeholder="field.settings.placeholder"
                :rows="field.settings.rows"
                :options="field.settings.options || []"
                class="col-12"
                outlined
                dense
                hide-bottom-space
                color="tertiary"
                @input="rehashEditedForm()"
                @change="rehashEditedForm()"
              />
            </div>
            <div v-if="field.type === 'html'" :key="`text_${index}`" class="col-xs-12">
              <component
                :is="field.tag"
                :id="`field_${field.index}`"
                :style="field.settings.style"
                class="no-margin"
                @input="rehashEditedForm()"
                @change="rehashEditedForm()"
                >{{ field.settings.value }}</component
              >
            </div>
          </template>
        </div>
      </q-card-section>
    </template>

    <slot v-else name="no-form">
      <RBtn type="link" :to="{ name: 'forms' }">Create custom form</RBtn>
    </slot>
  </q-card>
</template>

<script>
import hash from 'object-hash'
import { cloneDeep } from 'lodash'

export default {
  name: 'CustomFormRenderer',
  props: {
    form: {
      type: [Object, null],
      default: null
    }
  },
  data() {
    return {
      original: null,
      clone: null,
      editableForm: null
    }
  },
  watch: {
    editableForm(newVal) {
      this.clone = hash(newVal)
    },
    original() {
      this.init()
    },
    clone() {
      this.$emit('input', this.editableForm)
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.$set(this, 'editableForm', cloneDeep(this.form))
      this.original = hash(this.form)
      this.clone = hash(this.editableForm)
    },
    rehashEditedForm() {
      this.clone = hash(this.editableForm)
    }
  }
}
</script>

<style lang="stylus" scoped>
.option-group >>> .q-field__label {
  font-size 1.2rem !important
}
</style>
